export const AUTH_ERRORS = {
  invalid: 'invalid',
  unauthorized: 'unauthorized',
  forbidden: 'forbidden',
  blocked: 'blocked',
  unexpected: 'unexpected'
} as const

export const LOGIN_STATES = {
  login: 'login',
  mfa: 'mfa',
  blocked: 'blocked'
} as const

export const MFA_CODE_LENGTH = 6

export const DEFAULT_AUTH_RETRY_AFTER_SECONDS = 60

export const SECONDS_PER_MINUTE = 60

export const MIN_BLOCKED_MINUTES = 1
